var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifferenceMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3145_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5088 25.7557L28.0352 23.2294L26.351 21.5452L17.9299 29.9663L29.4382 41.4748L29.4385 41.4751C29.903 41.9395 30.6586 41.9395 31.1229 41.4752C31.3479 41.2501 31.4718 40.9511 31.4718 40.633C31.4718 40.3153 31.3481 40.0164 31.1235 39.7915C31.1233 39.7913 31.1231 39.7912 31.1229 39.791C31.1229 39.791 31.1227 39.7908 31.1226 39.7906L29.4386 38.1068C28.9735 37.6417 28.9735 36.8877 29.4385 36.4226C29.9036 35.9576 30.6577 35.9575 31.1228 36.4226L32.8071 38.1068C32.8073 38.1069 32.8074 38.1072 32.8077 38.1074C33.2721 38.5711 34.0271 38.5709 34.4913 38.1068C34.9556 37.6425 34.9557 36.8869 34.4913 36.4227C34.491 36.4223 34.4907 36.4219 34.4902 36.4215L32.8071 34.7384C32.3421 34.2733 32.3421 33.5193 32.8071 33.0542C33.2721 32.5892 34.0262 32.5891 34.4913 33.0541L36.1752 34.7379C36.1756 34.7383 36.1759 34.7387 36.1763 34.7391C36.6407 35.2024 37.3952 35.2024 37.8594 34.7387C37.8595 34.7385 37.8597 34.7385 37.8598 34.7383L37.8605 34.7375C38.0849 34.5126 38.2086 34.2139 38.2086 33.8962C38.2087 33.5785 38.0852 33.28 37.8608 33.0552L37.2984 32.4927C37.2982 32.4925 37.298 32.4924 37.2979 32.4921L33.0879 28.2822L30.5616 30.8085L30.5615 30.8086C29.8651 31.505 28.9502 31.8533 28.0353 31.8533C27.1204 31.8533 26.2055 31.505 25.509 30.8084C24.1163 29.4157 24.1162 27.1497 25.5084 25.7566C25.5084 25.7562 25.5086 25.7559 25.5088 25.7557Z",
    fill: "#FFFF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3122 20.2156L24.6668 19.861L22.9824 18.1768L14 27.1593L15.6842 28.8435L24.3122 20.2156Z",
    fill: "#FFFF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5623 24.0706C30.562 24.0709 30.5617 24.0713 30.5614 24.0716C30.5611 24.0719 30.5608 24.0721 30.5604 24.0724L27.1931 27.4399C27.1929 27.44 27.1929 27.44 27.1929 27.44C26.7286 27.9045 26.7287 28.6599 27.1929 29.1242C27.6574 29.5885 28.4129 29.5885 28.8773 29.1241L32.2457 25.7557C32.469 25.5324 32.772 25.4068 33.0877 25.4068C33.4036 25.4068 33.7065 25.5324 33.9298 25.7557L38.9822 30.8081L38.9824 30.8082L39.5436 31.3694C39.5436 31.3694 39.5437 31.3695 39.5438 31.3696C39.5438 31.3696 39.544 31.3698 39.5442 31.37L40.3859 32.2117L42.0701 30.5275L33.0877 21.5452L30.5623 24.0706Z",
    fill: "#FFFF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7721 19.8612L44.3159 29.405L46.0001 27.7208L36.4563 18.177L34.7721 19.8612Z",
    fill: "#FFFF81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3145_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferenceMarketplace);
export default __webpack_public_path__ + "static/media/difference_marketplace.d9097bab382b047ca2e4da7ebf49c55f.svg";
export { ForwardRef as ReactComponent };